import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
import { verifyCompanyOrgNumber, verifyPersonNumber } from "../application/validation";
import useRedirect from "./useRedirect";
import { Link, Typography } from "@material-ui/core";
import FormDialog from "./RegisterForm";

const useStyles = makeStyles({
  root: {
    display: "block",
    marginBottom: "1rem",
  },
  alert: {
    marginTop: ".5rem",
  },
  link: {
    marginLeft: ".2rem",
    marginRight: ".2rem",
  },
});

const getOperationalDistrubanceMessage = async () => {
    const response = await fetch("Partner/GetOpDistMessage", {
        method: "GET",
        //body: JSON.stringify({
        //    partnerIdentity: partnerIdentity,
        //}),
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
        },
    });
    if (response.ok) return response;
    if (response.status === 401) {
        return Promise.reject("Unauthorized");
    }
    const json = await response.json();
    return Promise.reject(json);
};


const tryVerifyPartner = async (partnerIdentity) => {
  const response = await fetch("verify", {
    method: "POST",
    body: JSON.stringify({
      partnerIdentity: partnerIdentity,
    }),
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
  });
  if (response.ok) return response;
  if (response.status === 401) {
    return Promise.reject("Unauthorized");
  }
  const json = await response.json();
  return Promise.reject(json);
};

export const Login = () => {
  const { redirect } = useRedirect();
  const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [opMessage, setopMessage] = useState(false);
  const { register, handleSubmit, errors, formState } = useForm({
    mode: "onChange",
  });
  const styles = useStyles();
  const { isValid } = formState;

    useEffect(() => {
        async function fetchMyAPI() {
            try {
                const response = await getOperationalDistrubanceMessage();
                const message = await response.json();
                setopMessage(message);
            } catch (error) {

            }
        }
        fetchMyAPI()
    }, [])

  const onSubmit = async ({ partnerIdentity }) => {
    try {
      setError(false);
      setLoading(true);
      const response = await tryVerifyPartner(partnerIdentity);
      const auth = await response.json();
      redirect("Dolda fel", `${auth.url}?t=${auth.token}&r=${auth.refreshToken}`);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  // 212000-0142
  return (
      <>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <TextField
                  id="partnerIdentity"
                  className={styles.root}
                  label="Organisationsnummer"
                  variant="outlined"
                  name="partnerIdentity"
                  fullWidth
                  inputRef={register({
                      required: "Obligatoriskt",
                      validate: (v) =>
                          verifyCompanyOrgNumber(v) ||
                          verifyPersonNumber(v) ||
                          "Ogiltigt organisations- eller personnummer",
                  })}
                  error={!!errors?.partnerIdentity}
                  helperText={errors?.partnerIdentity?.message}
              />
        <Button
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          fullWidth={true}
          disabled={!isValid || loading}
        >
          Logga in
        </Button>
          </form>
          {opMessage && (
          <Alert severity="error" className={styles.alert}>
              <AlertTitle>DriftStatus</AlertTitle>
              <Typography variant="caption" component="p">
                      {opMessage.message}
              </Typography>
              </Alert>
          )}
      {error && (
        <Alert severity="error" className={styles.alert}>
          <AlertTitle>Info</AlertTitle>
          <Typography variant="caption" component="p">
            Hej! Tack för din kontakt med oss.
          </Typography>
          <Typography variant="caption" component="p">
            Vi kan tyvärr inte hitta dig i vårt register. Klicka på knappen nedan för att komma vidare. <br/>
          <FormDialog />                    
          </Typography>
          <Typography variant="caption" component="p">
            Vi ser fram emot att få hjälpa dig och dina säljare framöver med Uppdaga dolda felförsäkringar!
          </Typography>
          <Typography variant="caption" component="p">
                      Om du behöver komma i kontakt med oss når du oss på: <br/>
                      <Link className={styles.link} href="mailto:saljservice@wtwco.com">
                          saljservice@wtwco.com
                      </Link>
                      eller
            <Link className={styles.link} href="tel:+46-8-5463 5990">
                          +46-8-5463 5990
            </Link>
          </Typography>
        </Alert>
      )}
    </>
  );
};
